import moment from 'moment-timezone';
import { secondsToTime } from "../helpers/moment-ex";

const getSensorData = (sensors, sensorName, isDeleteDevice = true) => {
    const sensorData = sensors[sensorName] && sensors[sensorName].data
        && Object.keys(sensors[sensorName].data).length > 0 ? sensors[sensorName].data : null;
    if (!sensorData) return sensorData;
    if (!isDeleteDevice) return sensorData;

    if (sensorData.device_id) delete sensorData.device_id;
    if (sensorData.device_uuid) delete sensorData.device_uuid;

    return sensorData;
};

export const parseSensorList = (egList, payload) => {
    const utcTS = moment.utc().valueOf();
    const sensorListById = {};

    egList.forEach(egDetail => {
        const item = {
            canInterfaceHealth: {
                canId: null,
                softwareVersion: null
            },
            canConnection: {
                state: null
            },
            gps: {
                lat: null,
                lng: null,
                ts: null
            },
            qConnection: {
                upTime: null,
                connected: null
            },
            battery: {
                state: null,
                percent: null,
                celsius: null
            }
        };

        const sensors = payload[egDetail.equipment_group_uuid] ? payload[egDetail.equipment_group_uuid] : null;
        if (!sensors) return sensorListById[egDetail.equipment_group_uuid] = item;

        const gps = getSensorData(sensors, "gps");
        if (gps) {
            item.gps.lat = gps.loc_point[1];
            item.gps.lng = gps.loc_point[0];
            item.gps.ts = gps.ts;
        }

        const qConnection = getSensorData(sensors, "q_connection");
        if (qConnection) {
            item.qConnection.upTime = secondsToTime((utcTS - qConnection.ts) / 1000, false, true);
            item.qConnection.connected = qConnection.connected;
        }

        const can = getSensorData(sensors, "can_interface_health");
        if (can) {
            item.canInterfaceHealth.canId = can.hasOwnProperty("can_id") ? can.can_id : null;
            item.canInterfaceHealth.softwareVersion = can.hasOwnProperty("software_ver") ? can.software_ver : null;
        }

        const canConnection = getSensorData(sensors, "can_connection");
        if (canConnection) {
            item.canConnection.state = canConnection.hasOwnProperty("state") ? canConnection.state : null;
        }

        const batteryLevel = getSensorData(sensors, "battery_level");
        if (batteryLevel) {
            item.battery.percent = batteryLevel.hasOwnProperty("percent") ? batteryLevel.percent : null;
        }

        const batteryState = getSensorData(sensors, "battery_charging_state");
        if (batteryState) {
            item.battery.state = batteryState.hasOwnProperty("state") ? batteryState.state : null;
        }

        const batteryTemp = getSensorData(sensors, "battery_temperature");
        if (batteryTemp) {
            item.battery.celsius = batteryTemp.hasOwnProperty("celsius") ? batteryTemp.celsius : null;
        }
        sensorListById[egDetail.equipment_group_uuid] = item;
    })

    return sensorListById;
};